import React from 'react'

interface CaseStudyItem {
  projectName: string | React.ReactNode
  client: string
  description?: string
  src: string
  alt: string
  id: string
  tags: [
    ...{
      tag: string
      href: string
    }[],
  ]
  isOneline: boolean
  linkToDetail?: string
}

export const caseStudyItems: CaseStudyItem[] = [
  {
    projectName: <>全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得</>,
    client: '株式会社JTBビジネストラベルソリューションズ',
    src: '/images/img/case/img_thum_jtbcwt.webp',
    alt: '全3回のUX/UIワークショップで、プロジェクトを前に進める共通言語を獲得',
    id: 'jtbcwt',
    tags: [
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      { tag: 'サービス', href: '/cases/service/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/jtb-cwt/',
  },
  {
    projectName: <>AI時代の開発生産性を支えるデザインシステムを構築</>,
    client: '株式会社アルダグラム',
    src: '/images/img/case/img_thum_aldagram.webp',
    alt: 'AI時代の開発生産性を支えるデザインシステムを構築',
    id: 'aldagram',
    tags: [
      {
        tag: 'デザインシステム構築支援',
        href: '/cases/design-system/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/aldagram/',
  },
  {
    projectName: <>海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現</>,
    client: 'SBIレミット株式会社',
    src: '/images/img/case/img_thum_remit.webp',
    alt: '海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現',
    id: 'remit',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'フロントエンド開発',
        href: '/cases/frontend-dev/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      { tag: '金融/不動産', href: '/cases/finance/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/remit/',
  },
  {
    projectName: (
      <>
        アジャイル開発により
        <br />
        Webサービスのアプリ化を2か月半で実現
      </>
    ),
    client: '株式会社SANU',
    src: '/images/img/case/img_thum_sanu.webp',
    alt: 'アジャイル開発により Webサービスのアプリ化を2か月半で実現',
    id: 'sanu',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'フロントエンド開発',
        href: '/cases/frontend-dev/',
      },
      { tag: 'サービス', href: '/cases/service/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/sanu/',
  },
  {
    projectName: <>課題解決率が大幅向上 - “使える生成AIチャット”をアジャイル×UX/UIでスピード実現</>,
    client: '株式会社大和総研',
    src: '/images/img/case/img_thum_dir.webp',
    alt: '不動産売買の契約業務をDX化 - UX/UI刷新でミスを削減し、作業時間を大幅に短縮',
    id: 'dir',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'フロントエンド開発',
        href: '/cases/frontend-dev/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'AI',
        href: '/cases/ai/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/dir/',
  },
  {
    projectName: (
      <>
        不動産売買の契約業務をDX化
        <br />- UX/UI刷新でミスを削減し、作業時間を大幅に短縮
      </>
    ),
    client: '株式会社不動産SHOP ナカジツ',
    src: '/images/img/case/img_thum_nakajitsu.webp',
    alt: '不動産売買の契約業務をDX化 - UX/UI刷新でミスを削減し、作業時間を大幅に短縮',
    id: 'nakajitsu',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'フロントエンド開発',
        href: '/cases/frontend-dev/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: '内製化支援',
        href: '/cases/inhouse-support/',
      },
      { tag: '金融/不動産', href: '/cases/finance/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/nakajitsu/',
  },
  {
    projectName: '利用者10％増 - UX/UI改善で転職成功に必須のアプリを開発',
    client: '株式会社キャリアデザインセンター',
    src: '/images/img/case/img_thum_cdc.webp',
    alt: '利用者10％増 - UX/UI改善で転職成功に必須のアプリを開発',
    id: 'typejobagentapp',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: '内製化支援',
        href: '/cases/inhouse-support/',
      },
      { tag: 'サービス', href: '/cases/service/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/career-design-center/',
  },
  {
    projectName: '新アプリ開発で顧客接点を一元化、グループ会社との連携も強化',
    client: '大和ハウスフィナンシャル株式会社',
    src: '/images/img/case/img_thum_heartone.webp',
    alt: '新アプリ開発で顧客接点を一元化、グループ会社との連携も強化',
    id: 'heartone',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'ZEBRA',
        href: '/cases/zebra/',
      },
      { tag: '金融/不動産', href: '/cases/finance/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/heart-one/',
  },
  {
    projectName: 'UX/UI刷新で顧客離れを防止、若年層にも支持されるミドルウェア設計',
    client: '株式会社セゾンテクノロジー',
    src: '/images/img/case/img_thum_hulft.webp',
    alt: 'UX/UI刷新で顧客離れを防止、若年層にも支持されるミドルウェア設計',
    id: 'hulft',
    tags: [
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'プロトタイピング・仮説検証',
        href: '/cases/prototyping/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/hulft/',
  },
  {
    projectName: '運用工数&コストの削減をデザインシステム導入で実現',
    client: '株式会社マクロミル',
    src: '/images/img/case/img_thum_macromill-designsystem.webp',
    alt: '運用工数&コストの削減をデザインシステム導入で実現',
    id: 'macromilldesignsystem',
    tags: [
      {
        tag: 'デザインシステム構築支援',
        href: '/cases/design-system/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/macromill-designsystem/',
  },
  {
    projectName: 'マニュアル不要の市場調査・分析SaaS開発を実現',
    client: '株式会社マクロミル',
    src: '/images/img/case/img_thum_coreka.webp',
    alt: 'マニュアル不要の市場調査・分析SaaS開発を実現',
    id: 'coreka',
    tags: [
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/coreka/',
  },
  {
    projectName: 'AI搭載アプリ開発で申し込み率改善、引越業務も効率化',
    client: 'アート引越センター株式会社',
    src: '/images/img/case/img_thum_guruttoai.webp',
    alt: 'AI搭載アプリ開発で申し込み率改善、引越業務も効率化',
    id: 'guruttoai',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      {
        tag: 'AI',
        href: '/cases/AI/',
      },
      { tag: 'サービス', href: '/cases/service/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/gurutto-ai/',
  },
  {
    projectName: '日本初のMaaSアプリ開発で、地方の高齢化に伴う課題の解決に貢献',
    client: 'オムロン ソーシアルソリューションズ株式会社',
    src: '/images/img/case/img_thum_meemo.webp',
    alt: '日本初のMaaSアプリ開発で、地方の高齢化に伴う課題の解決に貢献',
    id: 'meemo',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/meemo/',
  },
  {
    projectName: 'CVR107%改善 - システム改修なしでECサイトのUX/UIを最新化',
    client: '株式会社セブンネットショッピング',
    src: '/images/img/case/img_thum_7net.png',
    alt: 'CVR107%改善 - システム改修なしでECサイトのUX/UIを最新化',
    id: '7net',
    tags: [
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'flamingo',
        href: '/cases/flamingo/',
      },
      { tag: '小売/流通/卸', href: '/cases/retail/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/7net/',
  },
  {
    projectName: '共済マイページのユーザー数増加、リニューアル後も継続支援',
    client: '日本コープ共済生活共同組合連合会',
    src: '/images/img/case/img_thum_kyosaimypage.png',
    alt: '共済マイページのユーザー数増加、リニューアル後も継続支援',
    id: 'kyosaimypage',
    tags: [
      {
        tag: 'フロントエンド開発',
        href: '/cases/frontend-dev/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      { tag: '金融/不動産', href: '/cases/finance/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/kyosaimypage/',
  },
  {
    projectName: '売上約130%上昇 - グローバルECサイト構築で「真のDX」を実現',
    client: '会宝産業株式会社',
    src: '/images/img/case/img_thum_kaiho.png',
    alt: '売上約130%上昇 - グローバルECサイト構築で「真のDX」を実現',
    id: 'kaiho',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      { tag: '小売/流通/卸', href: '/cases/retail/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/kaiho/',
  },
  {
    projectName: 'CVR20%向上 - 美容総合メディアのデザインリニューアル',
    client: '株式会社セイファート',
    src: '/images/img/case/img_thum_seyfert.png',
    alt: 'CVR20%向上 - 美容総合メディアのデザインリニューアル',
    id: 'seyfert',
    tags: [
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'フロントエンド開発',
        href: '/cases/frontend-dev/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/seyfert/',
  },
  {
    projectName: '新築マンションの引越業務効率化をシステム開発で実現',
    client: 'アート引越センター株式会社',
    src: '/images/img/case/img_thum_mms.png',
    alt: '新築マンションの引越業務効率化をシステム開発で実現',
    id: 'mss',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      { tag: 'サービス', href: '/cases/service/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/mss/',
  },
  {
    projectName: 'NPBスコア分析WebソリューションのBtoC展開をUX/UI設計で支援',
    client: 'データスタジアム株式会社',
    src: '/images/img/case/img_thum_assistantrobo.png',
    alt: 'NPBスコア分析WebソリューションのBtoC展開をUX/UI設計で支援',
    id: 'assistantrobo',
    tags: [
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'フロントエンド開発',
        href: '/cases/frontend-dev/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/assistantrobo/',
  },
  {
    projectName: 'クラウドネイティブなシステム構築と日本向けUX/UI設計でアプリのローカライズを支援',
    client: 'イオン・シグナ・スポーツ・ユナイテッド株式会社',
    src: '/images/img/case/img_thum_tennispointapp.png',
    alt: 'クラウドネイティブなシステム構築と日本向けUX/UI設計でアプリのローカライズを支援',
    id: 'tennispointapp',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/tennispointapp/',
  },
  {
    projectName: '変化し続ける市場の最先端を走るために必須なDX推進を支援',
    client: '株式会社カネカ',
    src: '/images/img/case/img_thum_kaneka.png',
    alt: '変化し続ける市場の最先端を走るために必須なDX推進を支援',
    id: 'kaneka',
    tags: [
      {
        tag: '新規事業プロジェクト実行支援',
        href: '/cases/business-startup-support/',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/kaneka/',
  },
  {
    projectName: 'ユーザーとのコミュニケーション活性化のためのメタバース空間構築',
    client: '名古屋テレビ放送株式会社',
    src: '/images/img/case/img_thum_nagoyatv.png',
    alt: 'ユーザーとのコミュニケーション活性化のためのメタバース空間構築',
    id: 'nagoyatv',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/nagoyatv/',
  },
  {
    projectName: 'VRコンテンツの開発で災害に関する教育の効率化',
    client: '公益財団法人日本財団ボランティアセンター',
    src: '/images/img/case/img_thum_volnteer.png',
    alt: 'VRコンテンツの開発で災害に関する教育の効率化',
    id: 'volnteer',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      { tag: '公共/行政', href: '/cases/public/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/volunteer-ex/',
  },
  {
    projectName: 'PEACH JOHN 公式アプリ',
    client: '株式会社ピーチ・ジョン',
    src: '/images/img/case/img_thum_peachjohn.png',
    alt: 'PEACH JOHN 公式アプリ',
    id: 'peachjohn',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'ZEBRA',
        href: '/cases/zebra/',
      },
      { tag: '小売/流通/卸', href: '/cases/retail/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/peachjohn/',
  },
  {
    projectName: 'ニッセンオンライン',
    client: '株式会社ニッセン',
    src: '/images/img/case/img_thum_nissay.webp',
    alt: 'ニッセンオンライン',
    id: 'nissay',
    tags: [
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'flamingo',
        href: '/cases/flamingo/',
      },
      { tag: '小売/流通/卸', href: '/cases/retail/' },
    ],
    linkToDetail: '/cases/nissen/',
    isOneline: false,
  },
  {
    projectName: 'コンタクトレンズが簡単注文できるアプリ',
    client: '株式会社ビジョナリーホールディングス',
    src: '/images/img/case/img_thum_contactlens.webp',
    alt: 'コンタクトレンズが簡単注文できるアプリ',
    id: 'contactlens',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      {
        tag: 'ZEBRA',
        href: '/cases/zebra/',
      },
      { tag: '小売/流通/卸', href: '/cases/retail/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/visionaryholdings/',
  },
  {
    projectName: 'QUICK Global Alert',
    client: '株式会社QUICK',
    src: '/images/img/case/img_thum_quickglobalalert.webp',
    alt: 'QUICK Global Alert',
    id: 'quickglobalalert',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/quick/',
  },
  {
    projectName: '東京スター銀行アプリ',
    client: '株式会社野村総合研究所',
    src: '/images/img/case/img_thum_tokyostar.webp',
    alt: '東京スター銀行アプリ',
    id: 'tokyostar',
    tags: [
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      { tag: '金融/不動産', href: '/cases/finance/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/nri/',
  },
  {
    projectName: 'docomo Open Inovation Cloud',
    client: '株式会社NTTドコモ',
    src: '/images/img/case/img_thum_docomo.webp',
    alt: 'docomo Open Inovation Cloud',
    id: 'docomo',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'クラウドネイティブ',
        href: '/cases/cloudnative/',
      },
      {
        tag: 'フロントエンド開発',
        href: '/cases/frontend-dev/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/ntt/',
  },
  {
    projectName: 'Ultra Caddy',
    client: '株式会社Anchor',
    src: '/images/img/case/img_thum_ultracaddy.webp',
    alt: 'Ultra Caddy',
    id: 'ultracaddy',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'プロトタイピング・仮説検証',
        href: '/cases/prototyping/',
      },
      {
        tag: 'UX/UI改善',
        href: '/cases/uxui-improvement/',
      },
      { tag: 'IT/情報/通信', href: '/cases/telecommunications/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/anchor/',
  },
  {
    projectName: 'mirron',
    client: '大手化学メーカー',
    src: '/images/img/case/img_thum_mirron.webp',
    alt: 'mirron',
    id: 'mirron',
    tags: [
      {
        tag: 'アプリケーション開発',
        href: '/cases/application-development/',
      },
      {
        tag: 'PdM/PMM体制実行支援',
        href: '/cases/pdm-pmm/',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/mirron/',
  },
  {
    projectName: 'JOB理論1dayワークショップ',
    client: '株式会社安藤・間',
    src: '/images/img/case/img_thum_ando.webp',
    alt: 'JOB理論1dayワークショップ',
    id: 'ando',
    tags: [
      {
        tag: '組織開発・人材育成',
        href: '/cases/hip/',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/ando/',
  },
  {
    projectName: 'イノベーション ワークショップ',
    client: 'カヤバ株式会社',
    src: '/images/img/case/img_thum_kayaba.png',
    alt: 'イノベーション ワークショップ',
    id: 'kayaba',
    tags: [
      {
        tag: '組織開発・人材育成',
        href: '/cases/hip/',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/kayaba',
  },
  {
    projectName: 'DX-DAY アイデアソン',
    client: 'JFE エンジニアリング株式会社',
    src: '/images/img/case/img_thum_dxday.webp',
    alt: 'DX-DAY アイデアソン',
    id: 'dxday',
    tags: [
      {
        tag: '組織開発・人材育成',
        href: '/cases/hip/',
      },
      { tag: 'メーカー/製造/建設', href: '/cases/manufacturing/' },
    ],
    isOneline: false,
    linkToDetail: '/cases/jfe/',
  },
]
